export default {
  triggerButtonText: '{type} New Claim',
  toast: {
    title: 'Claims created',
  },
  form: {
    claimInventory: {
      claimTotal: 'Claim Total',
      claimTotalIncludingVAT: 'Total Incl VAT',
      vendorWithVATNote: 'VAT registered vendors will have their VAT % added to their total price',
    },
  },
};
